export default "__VITE_ASSET__BL7IPk39__"